import {
  Link
} from "react-router-dom";
import { Navbar, Nav, Button, Container } from 'react-bootstrap'
import market from './market.png'
import { shortenAddress } from "../utils/shortenAddress"

const Navigation = ({ web3Handler, account }) => {
  return (
    <Navbar expand="lg" bg="secondary" variant="dark">
      <Container>
        <Navbar.Brand href="/" className="change">
          <img src={market} width="40" height="40" className="" alt="" />
          &nbsp; NFT Marketplace
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav ">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/">Home</Nav.Link>
            <Nav.Link as={Link} to="/create">Create</Nav.Link>
            <Nav.Link as={Link} to="/my-listed-items">My Listed Items</Nav.Link>
            <Nav.Link as={Link} to="/my-purchases">My Purchases</Nav.Link>
            <Nav.Link as={Link} to="/explorer">Explorer</Nav.Link>
          </Nav>

          <Nav>
            {account ? (
              <Nav.Link
                href={`https://etherscan.io/address/${account}`}
                target="_blank"
                rel="noopener noreferrer"
                className="button nav-button btn-sm mx-4">
                <Button variant="outline-light">
                  {shortenAddress(account)}
                </Button>

              </Nav.Link>
            ) : (
              <Button onClick={web3Handler} variant="outline-light">Connect Wallet</Button>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>


  )

}

export default Navigation;